import ContractStatement from "@adapters/presenters/Reports/ContractStatement";
export default (useCases, actions) => {
    return {
        contract: new ContractStatement(actions, useCases),
    };
};
